import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultTabs from '../../../components/Accessibility/DefaultTabs';
import PageTitle from '../../../components/Accessibility/PageTitle';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { DoctorGC } from '../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/DoctorGC';
import { IHorarioDisponivel } from '../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel';
import { TypeCronicsScheduleEnum } from '../../../interfaces/enum/TypeCronicsScheduleEnum';
import { agendarGestao } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { UserData } from '../PrimeiroAgendamento/AgendarAtendimento/ConfirmarDados';
import StepConfirmacao from './StepConfirmacao';
import StepHorario from './StepHorario';
import StepProfissional from './StepProfissional';

const AgendarGC: React.FC = () => {

  const accessibility = useAccessibility();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const [profissionalSelecionado, setProfissionalSelecionado] = useState<DoctorGC>();
  const [horarioSelecionado, setHorarioSelecionado] = useState<IHorarioDisponivel>();
  const [idPlanoCuidPacAtendimentoSelecionado, setIdPlanoCuidPacAtendimentoSelecionado] = useState<string>('');
  const [step, setStep] = useState<TypeCronicsScheduleEnum>(TypeCronicsScheduleEnum.PROFISSIONAL);
  const [tipoAtendSelecionado, setTipoAtendSelecionado] = useState<string>();
  const stepLabels = ['Guia médico', 'Horário', 'Confirmação'];

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  const openModal = (
    icon: 'error' | 'success' | 'warning', title: string, subtitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon: icon,
      title: title,
      subTitle: subtitle,
      textButton: textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const goToStepHorario = (doctor: DoctorGC, tipoAtend: string, idPlanoCuidPac: string) => {
    setProfissionalSelecionado(doctor);
    setTipoAtendSelecionado(tipoAtend);
    setIdPlanoCuidPacAtendimentoSelecionado(idPlanoCuidPac)
    setStep(TypeCronicsScheduleEnum.DATA_HORARIO);
  }

  const goToFinalization = (horario: IHorarioDisponivel) => {
    setHorarioSelecionado(horario);
    setStep(TypeCronicsScheduleEnum.CONFIRMACAO);
  }

  const confirmSchedule = async (userData: UserData) => {
    setLoading(true);
    const response = await agendarGestao(profissionalSelecionado!, tipoAtendSelecionado!, horarioSelecionado!, userData, idPlanoCuidPacAtendimentoSelecionado);
    if (response?.status === 200) {
      openModal('success', 'Agendamento efetuado com sucesso!', '', 'Ir para o gestão de crônicos',
        () => navigate('/saudeBemEstar/gestaoDeCronicos'), () => navigate('/saudeBemEstar/gestaoDeCronicos')
      );
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro finalizar o agendamento. Tente novamente em instantes.');
    }
    setLoading(false);
  }

  return (
    <>
      {loading && <LoadingApp showLoading={loading} text='Carregando...' />}
      <div className='feature-container'>
        <PageTitle text='Agendar atendimento' />
        <DefaultTabs step={step - 1} stepLabels={stepLabels} onTabClick={step => setStep(step + 1)} />
        {step === TypeCronicsScheduleEnum.PROFISSIONAL &&
          <StepProfissional
            backStep={() => window.history.back()}
            onProceedProfissional={goToStepHorario}
            openModalError={openModalError}
          />
        }
        {step === TypeCronicsScheduleEnum.DATA_HORARIO &&
          <StepHorario
            backStep={() => setStep(TypeCronicsScheduleEnum.PROFISSIONAL)}
            doctor={profissionalSelecionado}
            tipoAtend={tipoAtendSelecionado}
            onProceedHorario={goToFinalization}
            openModalError={openModalError}
          />
        }
        {step === TypeCronicsScheduleEnum.CONFIRMACAO &&
          <StepConfirmacao
            backStep={() => setStep(TypeCronicsScheduleEnum.DATA_HORARIO)}
            doctor={profissionalSelecionado}
            confirmSchedule={confirmSchedule}
            horario={horarioSelecionado}
            openModalError={openModalError}
          />
        }
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default AgendarGC;